const [backgroundPostiionRight, backgroundPostiionBottom, backgroundPostiionLeft] = [0, 0, 0];
export const background = {
  position: 'fixed',
  right: backgroundPostiionRight,
  bottom: backgroundPostiionBottom,
  left: backgroundPostiionLeft,
  zIndex: '100',
  backgroundColor: 'rgba(0, 0, 0 , 0.4)',
  top: '150px',
  marginTop: '-150px',
};

export const modal = {
  position: 'absolute',
  minHeight: '223px',
  padding: '8px 16px', // token.padding.squish.mini.value
  minWidth: '370px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -60%)',
};
